import { render, staticRenderFns } from "./ancientBooks.vue?vue&type=template&id=c2a36066&scoped=true&"
import script from "./ancientBooks.vue?vue&type=script&lang=js&"
export * from "./ancientBooks.vue?vue&type=script&lang=js&"
import style0 from "./ancientBooks.vue?vue&type=style&index=0&id=c2a36066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a36066",
  null
  
)

export default component.exports